import { requiredCustomSelectScheme, validateConditionaly } from '@sravni/cosago-react-library/lib/validationSchemes';
import { mixed } from 'yup';

import { ANY_AUTO_MODEL_DICTIONARY_SELECT_OPTION } from 'constants/dictionaries';

import type { TCreditPurposeFormFields } from 'entities/creditForm';

export const validateAutoModelYear = () =>
  validateConditionaly<TCreditPurposeFormFields['autoYear']>(
    (autoModel: TCreditPurposeFormFields['autoModel']) => {
      return autoModel?.value !== ANY_AUTO_MODEL_DICTIONARY_SELECT_OPTION.value;
    },
    () => requiredCustomSelectScheme(),
    () => mixed().nullable(),
  )('autoModel');
